module.exports = __webpack_public_path__ + "img/NL.a51aed48.svg";